// extracted by mini-css-extract-plugin
export var footer = "_i9-0";
export var inherit = "_i9-1";
export var input = "_i9-2";
export var modalContent = "_i9-3";
export var quillEditor = "_i9-4";
export var subtitle = "_i9-5";